import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-filters-minute-table',
  templateUrl: './filters-minute-table.component.html',
  styleUrls: ['./filters-minute-table.component.scss']
})
export class FiltersMinuteTableComponent {
  @Output() geFilter: EventEmitter<string> = new EventEmitter();
  @Output() estadoFilter: EventEmitter<string | null> = new EventEmitter();
  public formFilter!: FormGroup;

  constructor(private fb: FormBuilder) {
    this.formFilter = this.fb.group({
      generalFilter: [''],
      estado: ['7'],
    });
  }

  ngOnInit(): void {}

  filtroGeneral(event: any) {
    const filterValue = event.target.value;
    this.geFilter.emit(filterValue);
  }

  filtroGeneralTemporizado(event: any) {
    setTimeout(() => {
      const filterValue = event.target.value;
      this.geFilter.emit(filterValue);
    }, 2000);
  }

  changeEstadoMinute(event: any) {
    let selected: string = this.formFilter.controls['estado']?.value;
    let estado: string | null;
    switch (selected) {
      case '1':
        estado = '1';
        break;
      case '2':
        estado = '2';
        break;
      case '3':
        estado = '3';
        break;
      case '6':
        estado = '6';
        break;  
      case '7':
        estado = '7';
        break;        
      case '0':
        estado = "0";
        break;
      default:
        estado = selected;
        break;
    }

    var datoInput = (document.getElementById("inputGeneral") as HTMLInputElement).value;
    this.estadoFilter.emit(estado);
    this.geFilter.emit(datoInput);

  }

}